const routeVisibleForRoles = (allowedRoles) => {
    // Get the roles from localStorage and parse them into an array
    const storedRoles = JSON.parse(localStorage.getItem('CLASHMATE_ROLE_LIST')) || [];
    // Check if any of the allowedRoles are present in storedRoles
    return allowedRoles.some(role => storedRoles.includes(role));
}

export default routeVisibleForRoles;